import { render, staticRenderFns } from "./payment-checkout.html?vue&type=template&id=88c02c28&scoped=true&external"
import script from "./payment-checkout.js?vue&type=script&lang=js&external"
export * from "./payment-checkout.js?vue&type=script&lang=js&external"
import style0 from "./payment-checkout.scss?vue&type=style&index=0&id=88c02c28&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c02c28",
  null
  
)

export default component.exports